import { Box, Flex } from "@nestoca/ui";
import { KeepI18ExprHappy } from "@shared/utils";
import clsx from "clsx";
import { useTranslation } from "react-i18next";

import styles from "./application-selector.module.scss";

import type {
  ApplicationSelectorOptionProps,
  ApplicationAddressOptionProps,
} from "./types";

export const ApplicationSelectorOption = ({
  id,
  address,
  stage,
  applicationId,
}: ApplicationSelectorOptionProps) => {
  const { t } = useTranslation("applications");

  return (
    <Flex
      className={clsx(styles.option, {
        [styles["option--selected"]]: id === applicationId,
      })}
    >
      <ApplicationAddressOption address={address} />
      <Box className={styles["option-stage"]}>
        {t(stage as KeepI18ExprHappy)}
      </Box>
    </Flex>
  );
};

export const ApplicationAddressOption = ({
  address,
}: ApplicationAddressOptionProps) => {
  return (
    <Box
      className={styles["option-address"]}
      data-dd-action-name="application selector address"
    >
      {address}
    </Box>
  );
};
